import ServicePageLayout from '../../components/feature/ServicePageLayout';

export default function DayNightBlindsPage() {
  return (
    <ServicePageLayout
      blindType="Day & Night Blinds"
      heroTitle="Day & Night Blinds Northampton"
      heroSubtitle="Modern Vision Blinds with Adjustable Light Control"
      introText="Day & Night blinds (also known as Vision or Zebra blinds) are one of the most popular modern blind styles in Northampton. Featuring alternating transparent and opaque fabric stripes, they offer exceptional light control and privacy with a sleek contemporary design."
      heroImage="https://public.readdy.ai/ai/img_res/247ec130a48de148c2fc2300c5c3a8fd.jpg"
      features={[
        { icon: 'ri-contrast-2-line', title: 'Adjustable Light Control', desc: 'Align the stripes to let light in or create privacy instantly' },
        { icon: 'ri-eye-off-line', title: 'Privacy & Views', desc: 'Enjoy natural light while maintaining privacy throughout the day' },
        { icon: 'ri-palette-line', title: 'Modern Style', desc: 'Contemporary design that complements any modern interior' },
        { icon: 'ri-tools-line', title: 'Easy Operation', desc: 'Smooth chain or cordless operation for effortless adjustment' },
        { icon: 'ri-home-smile-line', title: 'Versatile Application', desc: 'Perfect for living rooms, bedrooms, kitchens and offices' },
        { icon: 'ri-shield-check-line', title: 'Durable Quality', desc: 'High-quality fabrics designed to last for years' },
      ]}
      pricePerBlind="£129"
      wholeHousePrice="£999"
      benefits={[
        { icon: 'ri-check-line', text: 'Unique dual-layer fabric' },
        { icon: 'ri-check-line', text: 'Adjustable light & privacy' },
        { icon: 'ri-check-line', text: 'Cordless options available' },
        { icon: 'ri-check-line', text: 'Professional installation' },
        { icon: 'ri-check-line', text: 'Wide colour range' },
      ]}
      faqs={[
        {
          question: 'How do Day & Night blinds work?',
          answer: 'Day & Night blinds feature two layers of fabric with alternating transparent and opaque horizontal stripes. By adjusting the position of the fabric, you can align the stripes to let light through or overlap them for privacy and light blocking.'
        },
        {
          question: 'Are Day & Night blinds suitable for bedrooms?',
          answer: 'Yes, Day & Night blinds are excellent for bedrooms. When the opaque stripes are aligned, they provide good privacy and light control. For complete blackout, we recommend our Blackout Night Shade Framed Blinds.'
        },
        {
          question: 'Can I get Day & Night blinds in different colours?',
          answer: 'Absolutely! We offer Day & Night blinds in a wide range of colours and fabric options, from neutral whites and greys to bolder contemporary shades to match your interior design.'
        },
        {
          question: 'Are Day & Night blinds easy to clean?',
          answer: 'Yes, Day & Night blinds are very easy to maintain. Simply wipe them down with a damp cloth or use a vacuum cleaner with a brush attachment to remove dust.'
        },
        {
          question: 'Do you offer cordless Day & Night blinds?',
          answer: 'Yes, we offer both chain-operated and cordless options for Day & Night blinds. Cordless versions are ideal for homes with children and pets, providing a safer, cleaner look.'
        },
        {
          question: 'How long does installation take?',
          answer: 'Our professional installers typically complete Day & Night blind installation in 15-30 minutes per window, depending on the size and complexity of the fitting.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Most Popular Modern Blind Choice in Northampton
                </h3>
                <p className="text-gray-700 mb-6">
                  Day & Night blinds have become incredibly popular across Northampton homes thanks to their unique combination of style and functionality. Whether you're looking to upgrade your living room, bedroom, or home office, these versatile blinds offer the perfect balance of natural light, privacy, and contemporary design. Our expert team will help you choose the perfect fabric and colour to complement your interior, and our professional installation ensures a flawless finish every time.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=day%20and%20night%20zebra%20vision%20blinds%20in%20modern%20living%20room%20soft%20striped%20fabric%20elegant%20contemporary%20interior%20warm%20neutral%20tones%20no%20people%20professional%20photography&width=800&height=600&seq=daynight-add-001&orientation=landscape"
                  alt="Day and Night Blinds"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
}